import React, {useEffect, useMemo, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import './allProducts.css'
import {serchChildProductsForAdminCatalog} from "../../../../http/catalogApi";

import OneChildLine from "./oneChildLine/OneChildLine";
import {generateExcelExport} from "../../../../http/settingsApi";
import Pagination from "../../../../components/Paginstion";

const AllProducts = () => {

    const queryParams = new URLSearchParams(window.location.search)
    let page = +queryParams.get('page')

    let limit = 25
    if (!page || page <= 0) {
        page = 1
    }

    const [allCount, setAllCount] = useState(0)

    const Navigate = useNavigate()

    const [searchValueForChild,setSearchValueForChild] = useState("");
    const [sortParametr,setSortParametr] = useState("ASC");

    const [childProducts,setChildProducts] = useState(null);
    const [warehouses,setWarehouses] = useState(null);

    useEffect(() => {

        serchChildProductsForAdminCatalog("sort", sortParametr, searchValueForChild, page, limit).then(response => {
            let s = {};
            response.warehouses.forEach(function(item){
                s[item.code] = item;
            })
            setWarehouses(s)
            setChildProducts(response.rows)
            setAllCount(0)
            setAllCount(response.count)
            const maxPage =  Math.ceil(response.count / limit)
            if (page > maxPage) {
                Navigate(`/admindashboard/stocks?page=${maxPage}&mode=2`)
            }
        })

    },[sortParametr, searchValueForChild, page])

    return (
        <div className={"all_products_page_wrapper"}>
            <div className={"all_products_controll_bord"}>

                <div className={"info_bord_adm_panel"}>
                    <span className={"info_name"}>Остатки</span>
                </div>

            </div>

            <div className={"products_panel_wrapper"}>
                <div className="table_products_adm">
                    <div className={"filters_and_controll_products_block"}>

                        <div className={"search_and_sort_for_child"}>
                            <input placeholder={"Введите название или артикул"} className={"search_child_input"} value={searchValueForChild} onChange={e => setSearchValueForChild(e.target.value)} type="text"/>
                            <span className={"sort_heading_notificator"}>Направление сортировки</span>
                            <div className={"sort_container_test_wrapper"}>
                                <span
                                    className={ sortParametr === "ASC" ? "btn_for_control_catalog_mode active" :  "btn_for_control_catalog_mode" }
                                    onClick={e=> setSortParametr("ASC")}
                                >по возрастанию</span>
                                <span
                                    className={ sortParametr === "DESC" ? "btn_for_control_catalog_mode active" :  "btn_for_control_catalog_mode" }
                                    onClick={e => setSortParametr("DESC")}
                                >по убыванию </span>
                            </div>
                        </div>

                    </div>

                    <div className={"wrapper_for_operating_mode_container"}>
                        <div className={"wrapper_for_operating_mode_container"}>
                            <div className={"adm_marker_block"}>
                                <div className={"lft_block"}>
                                    <div className={"info_of_product id"}>ID</div>
                                    <div className={"info_of_product img"}>IMG</div>
                                    <div className={"info_of_product name" }> Название </div>
                                    <div className={"info_of_product color"}> Цвет</div>
                                    <div className={"info_of_product color"}> Артикул </div>
                                    <div className={"info_of_product status"}> Остаток </div>
                                    <div className={"info_of_product status"}> Магазин </div>
                                </div>
                            </div>
                            <div className="product_wrapper_gener">
                                {
                                    childProducts ?
                                        childProducts.filter(item => (item && item.product && item.product.id && item.color && item.color)).map(item => <OneChildLine key={item.id} item={item} warehouses={warehouses}/>)
                                        : ""
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="pagination_adm_wrapper">
                <Pagination page={page} limit={limit} count={allCount} />
            </div>
        </div>
    );
};

export default AllProducts;